import 'babel-polyfill';

import { SiteUtilities } from './utils';
const redirectElements = ['.redirect-button', '.redirect-link', '[data-selector=redirect-link]'];

const redirectThankYou = (product) => {
  var growsumokey;
  const productDomain = $('#signup-endpoint').val().match(/(\..*\.)(com|io|dev)/)[0];
  const redirectUrlRegex = new RegExp(`^(http|https)://([a-zA-Z0-9].*)${productDomain}/([a-zA-Z0-9].*)`);
  const trackObj = {
    skipSignupPerformanceLogAPI: false,
    delaySignupPerformanceLogApi: false,
    isRedirectStarted: false,
    product
  };
  if (product && product !== null) {
    redirectElements.forEach((element) => {
      $(element).on('click', function () {
        const aTag = $(this).find('a')[0];
        const url = this.getAttribute('href') || (aTag && aTag.getAttribute('href'));
        if (!url || trackObj.isRedirectStarted) return;
        trackObj.isRedirectStarted = true;
        $(this).css('pointer-events', 'none');
        SiteUtilities.triggersignupPerformanceLogApi(true);
      });
    });

    switch (product) {
      case 'fdesk':
        growsumokey = 'pk_ZUb1nXFPs1riXIiwEozmL4trdtiWngWL';
        freshdeskRedirect(redirectUrlRegex, growsumokey, productDomain, false, trackObj, true);
        break;
      case 'fservice':
        growsumokey = 'pk_OrZ1wKWPqoR5Rj4K6xgniKy1ATxs9VcX';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fteam':
        growsumokey = 'pk_savEQCbAnVmO1SGPkmoExxSKia5GwSh9';
        freshteamRedirect(growsumokey, trackObj);
        break;
      case 'fcaller':
        growsumokey = 'pk_GKfKnrVOkoeBT4pXIKzVakrlgTRmpDPA';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fchat':
        growsumokey = 'pk_S2P0ZRTBsc7OjyRUsxfNeyCSy3Ye8HNE';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fstatus':
        genericRedirect();
        break;
      case 'fping':
        genericRedirect();
        break;
      case 'frelease':
        freleaseRedirect();
        break;
      case 'fworks':
        genericRedirect();
        break;
      case 'fwcrm':
        growsumokey = 'pk_I0c7qjS8TciKE3HTMqa5yalHg8J6f8ES';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fsales':
        growsumokey = 'pk_I0c7qjS8TciKE3HTMqa5yalHg8J6f8ES';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fsuccess':
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj);
        break;
      case 'fmarketer':
        growsumokey = 'pk_C37DQPQy8woOfMQC7ixoBThnqyTGlJ9q';
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj, true);
        break;
      case 'fsurvey':
        genericRedirect(redirectUrlRegex, growsumokey, productDomain, trackObj);
        break;
      case 'fwcssuite':
        growsumokey = 'pk_ZUb1nXFPs1riXIiwEozmL4trdtiWngWL';
        freshdeskRedirect(redirectUrlRegex, growsumokey, productDomain, false, trackObj, true);
        break;
      default:
        SiteUtilities.log(
          'Encountered product without thank-you redirect configuration',
          'error',
          'thankyou.redirectThankYou',
          0
        );
        return false;
    }

    if (!trackObj.skipSignupPerformanceLogAPI && localStorage.getItem('signupPerformanceLogData')) {
      const redirectBtnElements = $('.redirect-button');
      const redirectDelay = (redirectBtnElements.attr('data-redirect-seconds') || 0) - 5;
      if (trackObj.delaySignupPerformanceLogApi && redirectDelay > 0) {
        setTimeout(function () {
          SiteUtilities.triggersignupPerformanceLogApi(false);
        }, (redirectDelay * 1000));
      } else {
        SiteUtilities.triggersignupPerformanceLogApi(false);
      }
    }
  }
};

const finalRedirect = (url, trackObj = {}) => {
  const postToPartner = SiteUtilities.getParameterByName('post_to_partner');
  if (postToPartner === 'true') {
    window.parent.postMessage(JSON.stringify({ url, signup_finished: true }), '*');
  } else {
    if (trackObj.isRedirectStarted) return;
    trackObj.isRedirectStarted = true;
    redirectElements.forEach((element) => $(element).css('pointer-events', 'none'));
    SiteUtilities.redirectToURL(url);
  }
};

const redirectToUrl = (buttonRedirect, redirectDelay, url, trackObj) => {
  if (buttonRedirect) {
    // Adding 3000ms since the getStarted btn will be displayed after a timeout of 3s
    localStorage.setItem('getStartedBtnDisplayTime', new Date(new Date().getTime() + 3000).toISOString());
    trackObj.delaySignupPerformanceLogApi = true;
    setTimeout(() => {
      $('.redirect-button').attr('href', url).removeClass('hide');
      $('.loading-spinner').hide();
    }, 3000);
  }
  localStorage.setItem('productRedirectStartTime', new Date(new Date().getTime() + (redirectDelay || 3000)).toISOString());
  let timeout = setTimeout(() => {
    if (trackObj.isRedirectStarted) return;
    trackObj.isRedirectStarted = true;
    redirectElements.forEach((element) => $(element).css('pointer-events', 'none'));
    SiteUtilities.redirectToURL(url);
  }, redirectDelay || 3000);

  // check if page has video, and if video is played timeout to redirect page is resetted
  const $videoElement = $('.wistia_embed');
  if ($videoElement.length > 0) {
    window._wq = window._wq || [];
    $videoElement.each(function (index, element) {
      const videoClasses = $(element)[0].getAttribute('class').split(' ');
      const videoId = videoClasses.filter(i => i.match('^wistia_async_'))[0].replace(/wistia_async_/g, '');
      window._wq.push({ id: videoId,
        onReady: function (video) {
          video.bind('play', function () {
            clearTimeout(timeout);
          });
          video.bind('end', function () {
            timeout = setTimeout(() => {
              if (trackObj.isRedirectStarted) return;
              trackObj.isRedirectStarted = true;
              redirectElements.forEach((element) => $(element).css('pointer-events', 'none'));
              SiteUtilities.redirectToURL(url);
            }, redirectDelay || 3000);
          });
        }
      });
    });
  }
};

const freleaseRedirect = () => {
  const url = localStorage.getItem('redirect_url');
  localStorage.removeItem('redirect_url');
  const loadingSpinner = jQuery('.loading-spinner');
  if (url !== null) {
    // adding 3000ms since the redirect happens after 3000ms timeout
    localStorage.setItem('productRedirectStartTime', new Date(new Date().getTime() + 3000).toISOString());
    loadingSpinner.show();
    jQuery('.redirect-link').attr('href', url);
    setTimeout(() => {
      finalRedirect(url);
    }, 3000);

    const dynamicText = jQuery('.thankyou-text-dynamic');
    setTimeout(() => {
      dynamicText.each(function (index) {
        const _t = jQuery(this);
        setTimeout(() => {
          dynamicText.removeClass('active');
          _t.addClass('active');
        }, 1250 * index * 1.5);
      });
    }, 500);
  }
};

const freshteamRedirect = (growsumokey, trackObj) => {
  // Stop Redirection to app in mobile.
  const url = localStorage.getItem('redirect_url');
  localStorage.removeItem('redirect_url');
  // let userAgent = SiteUtilities.getUserAgentForMobile();
  const paraHTML = jQuery('.thankyou-text');
  const textContentLen = paraHTML.length;
  const loadingSpinner = jQuery('.loading-spinner');
  const mobileSupportText = 'Please check your email for account information and login through your laptop/PC.';
  const playStoreLink = 'https://play.google.com/store/apps/details?id=com.freshdesk.freshteam';
  const userAgent = SiteUtilities.getUserAgentForMobile();
  growsumoSignup(growsumokey);

  function handleMobile () {
    // Hide the other paras except the first one and change the content of first para
    for (let l = 0; l < textContentLen; l++) {
      if (l !== 0) {
        jQuery(paraHTML[l]).hide();
      }
    }
    loadingSpinner.hide();
    jQuery(paraHTML[0]).text(mobileSupportText);
  }
  if (jQuery(window).width() < 600) {
    if (userAgent === 'Android') {
      handleMobile();
      jQuery('.mobile-links.app-stores').html(SiteUtilities.getAppLink(playStoreLink, userAgent));
    } else {
      handleMobile();
    }
  } else {
    // Redirect if not mobile
    if (url !== null) {
      // adding 3000ms since the redirect happens after 3000ms timeout
      localStorage.setItem('productRedirectStartTime', new Date(new Date().getTime() + 3000).toISOString());
      loadingSpinner.show();
      jQuery('.redirect-link').attr('href', url);
      setTimeout(() => {
        // capture the account domain in GA by pushing it to the data layer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer = [{
          tvc_sub_domain: url.replace(/\/signup_complete.*/, '')
        }];
        finalRedirect(url, trackObj);
      }, 3000);
      const dynamicText = jQuery('.thankyou-text-dynamic');
      setTimeout(() => {
        dynamicText.each(function (index) {
          const _t = jQuery(this);
          setTimeout(() => {
            dynamicText.removeClass('active');
            _t.addClass('active');
          }, 1250 * index * 1.5);
        });
      }, 500);
    }
  }
};

const growsumoSignup = (growsumokey, type, productDomain) => {
  pollGrowSumo().then(() => {
    try {
      // growsumo handlers
      var gsdata = JSON.parse(localStorage.getItem('gsdata'));
      SiteUtilities.addToPerformance('beforeGrowSumo', performance.now());
      growsumo._initialize(growsumokey);
      growsumo.data.name = gsdata.first_name;
      growsumo.data.email = gsdata.email_id;
      growsumo.data.customer_key = gsdata.account_id;
      if (type === 'generic') {
        if (gsdata.domain_link) {
          growsumo.data.customer_key = gsdata.domain_link;
        } else if (gsdata.domain_name) {
          growsumo.data.customer_key = gsdata.domain_name + productDomain;
        }
      }
      growsumo.createSignup();
      SiteUtilities.addToPerformance('afterGrowSumo', performance.now());
      localStorage.removeItem('gsdata');
    } catch (e) {
      localStorage.removeItem('gsdata');
    }
  }, () => {
    if (window.OptanonActiveGroups !== undefined && window.OptanonActiveGroups.indexOf('C0004') > -1) {
      SiteUtilities.log(
        'Timeout in polling window.growsumo',
        'error',
        'thankyou.js',
        1,
        window.OptanonActiveGroups
      );
    }
  });
};

const productRedirect = (referrerUrl, regEx) => {
  if (regEx.test(referrerUrl)) {
    const referrerUrlObj = new window.URL(referrerUrl);
    return referrerUrlObj.protocol + '//' + referrerUrlObj.hostname + '/accounts/anonymous_signup_complete';
  }
};

const genericRedirect = (regex, growsumokey, productDomain, trackObj = {}, logGrowSumoLeads = false) => {
  const dynamicText = jQuery('.thankyou-text-dynamic');
  // Get the redirect url from the local storage
  const url = localStorage.getItem('redirect_url');
  localStorage.removeItem('redirect_url');
  // First check if regex is defined. If its not then simply redirect to product
  // page and return
  if (typeof regex === 'undefined') {
    localStorage.setItem('productRedirectStartTime', new Date().toISOString());
    jQuery('.redirect-link').attr('href', url);
    setTimeout(() => {
      dynamicText.each(function (index) {
        const _t = jQuery(this);
        setTimeout(() => {
          dynamicText.removeClass('active');
          _t.addClass('active');
        }, 1250 * index * 1.5);
      });
    }, 500);
    finalRedirect(url, trackObj);
    return;
  }

  const spamScore = localStorage.getItem('risk_score');
  if (spamScore !== null && !isNaN(parseInt(spamScore, 10))) {
    try {
      window.dataLayer.push({ risk_score: parseInt(spamScore, 10) });
      window['risk_score'] = parseInt(spamScore, 10);
    } catch (e) {}
    localStorage.removeItem('risk_score');
  }
  if (logGrowSumoLeads) {
    parseGrowsumoPayload(growsumokey, productDomain);
  } else {
    growsumoSignup(growsumokey, 'generic', productDomain);
  }

  const callFinalRedirect = () => {
    // For fservice prod redirect this fn will be called after 3000ms timeout, hence setting.
    const regexCheck = regex.test(url);
    if (regexCheck) {
      jQuery('.redirect-link').attr('href', url);
      /*
        Additionally, enable creation of redirect link with editor's built-in <a> tool.
        Do not remove the above selector for the sake of existing configurations.
      */
      jQuery('[data-selector=redirect-link]').attr('href', url);
      setTimeout(() => {
        dynamicText.each(function (index) {
          const _t = jQuery(this);
          setTimeout(() => {
            dynamicText.removeClass('active');
            _t.addClass('active');
          }, 1250 * index * 1.5);
        });
      }, 500);

      // capture the account domain in GA by pushing it to the data layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer = [{
        tvc_sub_domain: url.replace(/\/signup_complete.*/, '')
      }];
      localStorage.setItem('productRedirectStartTime', new Date(new Date().getTime() + 3000).toISOString());
      setTimeout(() => {
        if ($('body').attr('data-product-name') === 'fchat') {
          const fireTags = setInterval(() => {
            const dataLayer = window.dataLayer || [];
            const gtmLoadIndex = dataLayer.findIndex(element => {
              return element.event === 'gtm.load';
            });
            if (gtmLoadIndex !== -1) {
              clearInterval(fireTags);
              finalRedirect(url, trackObj);
            }
          }, 100);
          setTimeout(() => {
            SiteUtilities.log(
              'Thank you 10 seconds timeout reached. gtm.load didn\'t fire',
              'error',
              'thankyou.js',
              1
            );
            finalRedirect(url, trackObj);
          }, 7000);
        } else {
          finalRedirect(url, trackObj);
        }
      }, 3000);
      if (trackObj.skipSignupPerformanceLogAPI) {
        SiteUtilities.triggersignupPerformanceLogApi(false);
      }
    }
  };

  if ($('body').attr('data-product-name') === 'fservice' && localStorage.getItem('kinesisPost') === 'yes') {
    trackObj.skipSignupPerformanceLogAPI = true;
    SiteUtilities.addToPerformance('beforeKinesis', performance.now());
    localStorage.setItem('fmarketerStartTime', new Date().toISOString());
    SiteUtilities.postToKinesis().then((res) => {
      localStorage.removeItem('kinesisPost');
    }).catch((e) => {
      console.log('kinesis error', e);
      SiteUtilities.log(
        'Error in posting to Kinesis API endpoint',
        'error',
        'thankyou.js',
        1,
        e
      );
    }).always(() => {
      localStorage.setItem('fmarketerEndTime', new Date().toISOString());
      localStorage.removeItem('kinesisFmCollectorPost');
      localStorage.removeItem('kinesisPerformance');
      // localStorage.removeItem('kinesisGrowSumoPost');
      callFinalRedirect();
    });
  } else {
    callFinalRedirect();
  }
};

const freshdeskRedirect = (regex, growsumokey, productDomain, buttonRedirect = false, trackObj, logGrowSumoLeads = false) => {
  const dynamicText = jQuery('.thankyou-text-dynamic');
  // Get the redirect url from the local storage
  const url = localStorage.getItem('redirect_url');
  const redirectButton = $('.redirect-button');
  let redirectDelay = 0;
  if (redirectButton.length > 0) {
    buttonRedirect = true;
    // fetching time and converting it to micsrosecond
    redirectDelay = redirectButton.attr('data-redirect-seconds') * 1000;
  }
  if (url) {
    localStorage.removeItem('redirect_url');
  }
  // Other constants
  const demoAccount = SiteUtilities.getParameterByName('demo_account');
  const referrerUrl = document.referrer;
  const postToPartner = SiteUtilities.getParameterByName('post_to_partner');
  const referrerRegex = new RegExp(`/demo(?:help|assist|service|care|aid|relations|desk|team|-help|-assist|-service|-care|-aid|-relations|-desk|-team)?[0-9]{13}${productDomain}/`);

  if (demoAccount === 'true') {
    const productRedirectUrl = productRedirect(referrerUrl, referrerRegex);
    if (productRedirectUrl) {
      if (postToPartner === 'true') {
        SiteUtilities.triggersignupPerformanceLogApi(true);
        window.parent.postMessage(JSON.stringify({ url, signup_finished: true }), '*');
      } else {
        redirectToUrl(buttonRedirect, redirectDelay, productRedirectUrl, trackObj);
      }
      return false;
    }
  }

  // First check if regex is defined. If its not then simply redirect to product
  // page and return
  if (typeof regex === 'undefined') {
    jQuery('.redirect-link').attr('href', url);
    setTimeout(() => {
      dynamicText.each(function (index) {
        const _t = jQuery(this);
        setTimeout(() => {
          dynamicText.removeClass('active');
          _t.addClass('active');
        }, 1250 * index * 1.5);
      });
    }, 500);
    // Video Onboarding Redirect - Page redirects to product on button click
    if (postToPartner === 'true') {
      SiteUtilities.triggersignupPerformanceLogApi(true);
      window.parent.postMessage(JSON.stringify({ url, signup_finished: true }), '*');
    } else {
      redirectToUrl(buttonRedirect, redirectDelay, url, trackObj);
    }
    return;
  }

  const spamScore = localStorage.getItem('risk_score');
  if (spamScore !== null && !isNaN(parseInt(spamScore, 10))) {
    try {
      window.dataLayer.push({ risk_score: parseInt(spamScore, 10) });
      window['risk_score'] = parseInt(spamScore, 10);
    } catch (e) {}
    localStorage.removeItem('risk_score');
  }

  // Handling data for growsumo.
  if (logGrowSumoLeads) {
    parseGrowsumoPayload(growsumokey, productDomain);
  } else {
    growsumoSignup(growsumokey);
  }

  // Stop Redirection to app in mobile.
  const userAgent = SiteUtilities.getUserAgentForMobile();
  const paraHTML = jQuery('.thankyou-text');
  const loadingSpinner = jQuery('.loading-spinner');
  const sucessMark = jQuery('.success-mark');

  if (userAgent !== '') {
    const formDetails = JSON.parse(localStorage.getItem('form_details'));
    const email = formDetails && formDetails.email;
    const perishableToken = (localStorage.getItem('perishable_token') !== undefined) ? localStorage.getItem('perishable_token') : '';
    const domain = (localStorage.getItem('product_domain') !== undefined) ? localStorage.getItem('product_domain') : '';
    const dynamicLink = 'https://freshdesk.page.link/?link=https://app.freshdesk.com/signup_complete?token=' + perishableToken + '%26domain=' + domain + '%26email=' + email + '&apn=com.freshdesk.helpdesk&ibi=com.freshdesk.Freshdesk&isi=849713306';
    localStorage.removeItem('perishable_token');
    localStorage.removeItem('product_domain');
    const externalLink = (/iOS|Android/).test(userAgent) ? dynamicLink : '';
    const mobileSupportText = 'Freshdesk is best experienced on a desktop. Please access your new account from your desktop, and we will send you an email with your details shortly.';
    const unSupportedText = 'We\'ve set up your account. For better experience, access our app from a desktop.';

    // Hide the other paras except the first one and change the content of first para
    paraHTML.not(':first').hide();
    loadingSpinner.hide();
    if (userAgent !== 'Windows Phone' && userAgent !== 'Mobile') {
      paraHTML.eq(0).text(mobileSupportText);
      sucessMark.addClass('check-mark');
      jQuery('.mobile-links.app-stores').html(SiteUtilities.getAppLink(externalLink, userAgent));
    } else {
      paraHTML.eq(0).text(unSupportedText);
    }
  } else {
    const regexCheck = regex.test(url);
    if (regexCheck) {
      jQuery('.redirect-link').attr('href', url);
      setTimeout(() => {
        dynamicText.each(function (index) {
          const _t = jQuery(this);
          setTimeout(() => {
            dynamicText.removeClass('active');
            _t.addClass('active');
          }, 1250 * index * 1.5);
        });
      }, 500);

      // capture the account domain in GA by pushing it to the data layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer = [{
        tvc_sub_domain: url.replace(/\/signup_complete.*/, '')
      }];
      // Video Onboarding Redirect - Page redirects to product on button click
      if (postToPartner === 'true') {
        SiteUtilities.triggersignupPerformanceLogApi(true);
        window.parent.postMessage(JSON.stringify({ url, signup_finished: true }), '*');
      } else {
        redirectToUrl(buttonRedirect, redirectDelay, url, trackObj);
      }
    }
  }
};

const pollGrowSumo = () => {
  return new Promise(function (resolve, reject) {
    let i = 0;
    const pollLength = 15, pollSpeed = 200;
    const poll = () => {
      i += 1;
      if (window.growsumo) {
        resolve();
        clearInterval(handler);
      } else if (i >= pollLength) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject();
        clearInterval(handler);
      }
    };
    const handler = setInterval(poll, pollSpeed);
  });
};

const parseGrowsumoPayload = (growsumokey, productDomain) => {
  const payload = SiteUtilities.buildGrowSumoPayload(growsumokey, productDomain);
  SiteUtilities.addToPerformance('beforeGrowSumo', performance.now());
  const admitadPayload = SiteUtilities.buildAdmitadPayload(payload.customer_key);
  SiteUtilities.postToKinesis({ growSumoPost: payload, admitadPost: admitadPayload }).then(() => {
    SiteUtilities.addToPerformance('afterGrowSumo', performance.now());
  }).catch((e) => {
    SiteUtilities.log(
      'Error in posting to growsumpe Kinesis API endpoint',
      'error',
      'thankyou.js',
      1,
      e
    );
  }).always(() => {
    localStorage.removeItem('gsdata');
  });
};

const thankyou = {
  redirectThankYou
};
window.thankyou = thankyou;

export { thankyou };
